import client from "./APIClient"

export default class CloudWatchApi {
  static logExecutionTime = executionTime => {
    return client(
      "cloudwatch/metric",
      { method: "POST", body: { execution_time: executionTime } }
    )
  }

  static logMessage = (logGroupName, logData) => {
    return client(
      "cloudwatch/log",
      { method: "POST", body: { log_group_name: logGroupName, log_data: logData } }
    )
  }
}
